import { Component, Vue, Prop } from 'vue-property-decorator';
import { CreateElement, VNodeData, VNode } from 'vue';
import ClTypography from '../ClTypography';

@Component({
  components: { ClTypography }
})
export default class ClCardHeader extends Vue {
  /**
   * The root component tag.
   */
  @Prop({
    default: 'div',
    type: String
  })
  public component!: string;

  /**
   * If true, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the title text, and optional subheader text
   * with the Typography component.
   */
  @Prop({
    default: false,
    type: Boolean
  })
  public disableTypography!: boolean;

  /**
   * The content of the subheader.
   */
  @Prop({
    type: String
  })
  public subheader!: string;

  /**
   * These props will be forwarded to the subheader
   * (as long as disableTypography is not true).
   */
  @Prop({
    default: () => ({}),
    type: Object
  })
  public subheaderTypographyProps!: object;

  /**
   * The content of the title.
   */
  @Prop({
    type: String
  })
  public title!: string;

  /**
   * These props will be forwarded to the title
   * (as long as disableTypography is not true).
   */
  @Prop({
    default: () => ({}),
    type: Object
  })
  public titleTypographyProps!: object;

  render(h: CreateElement) {
    const rootData: VNodeData = {
      class: 'cl-card-header'
    };
    const contentData: VNodeData = {
      class: 'cl-card-header__content'
    };
    const titleData: VNodeData = {
      class: {
        'cl-card-header__title': true
      },
      props: {
        component: 'span',
        variant: this.$slots.avatar ? 'body2' : 'h6',
        ...this.titleTypographyProps
      }
    };
    const title: VNode = h('cl-typography', titleData, this.title);
    const subheaderData: VNodeData = {
      class: 'cl-card-header__subheader',
      props: {
        color: 'textSecondary',
        component: 'span',
        variant: this.$slots.avatar ? 'body2' : 'body1',
        ...this.subheaderTypographyProps
      }
    };
    const subheader: VNode = h('cl-typography', subheaderData, this.subheader);
    const avatarData: VNodeData = {
      class: 'cl-card-header__avatar'
    };
    const avatar: VNode | undefined =
      this.$slots.avatar && h('div', avatarData, this.$slots.avatar);
    const actionData: VNodeData = {
      class: 'cl-card-header__action'
    };
    const action: VNode | undefined =
      this.$slots.action && h('div', actionData, this.$slots.action);
    return h(this.component, rootData, [
      avatar,
      h('div', contentData, [title, subheader]),
      action
    ]);
  }
}
